import ReauthenticationProvider from "components/ReauthenticationProvider";
import AnalyticsProviders from "./AnalyticsProviders";
import AthletesProvider from "providers/AthletesProvider";
import GroupsProvider from "providers/GroupsProvider";
import AthleteMonitoringStatusesProvider from "providers/AthleteMonitoringStatusesProvider";
import RAGSettingsProvider from "providers/RAGSettingsProvider";
import DateTimePickers from "components/mui5/DateTimePickers";
import OnBoardingProvider from "providers/OnBoardingProvider";
import LoadingProvider from "providers/LoadingProvider";
import SidebarProvider from "components/Sidebar/SidebarProvider";

interface ConfigProvidersProps {
  children: React.ReactNode;
}

/**
 * ConfigProviders is a wrapper component for the secondary configuration providers
 * used in the application. They are not essential for the initial loading of the app,
 * but provide additional functionality such as analytics, reauthentication, and user data management.
 */
function ConfigProviders(props: ConfigProvidersProps) {
  return (
    <LoadingProvider>
      <AnalyticsProviders />
      <ReauthenticationProvider>
        <AthletesProvider>
          <GroupsProvider>
            <AthleteMonitoringStatusesProvider>
              <RAGSettingsProvider>
                <DateTimePickers.LocalizationProvider>
                  <OnBoardingProvider>
                    <SidebarProvider>{props.children}</SidebarProvider>
                  </OnBoardingProvider>
                </DateTimePickers.LocalizationProvider>
              </RAGSettingsProvider>
            </AthleteMonitoringStatusesProvider>
          </GroupsProvider>
        </AthletesProvider>
      </ReauthenticationProvider>
    </LoadingProvider>
  );
}

export default ConfigProviders;
